import React, { memo } from "react";
import Choices from "../Choices";
import ReusableAccordian from "../ReusableAccordion";
import { MenuItem, InputLabel, FormControl, Select } from "@mui/material";
import { Image } from "cloudinary-react";
import { kerfChoices, options } from "./defaults";
import KerfCustomOptions from "./KerfCustomOptions";
import { RowLayout } from "../../util/accordianStyles";
import { styled } from "@mui/material/styles";
import useKerfSelector from "./useKerfSelector";

const StyledFormControl = styled(FormControl)(({ theme }) => ({
  margin: theme.spacing(1),
  minWidth: 150,
  height: 20,
}));

const StyledDivSpacing = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  padding: theme.spacing(1, 2),
}));

const StyledDivLeftDivide = styled("div")(({ theme }) => ({
  marginBottom: 10,
  marginTop: 20,
  alignItems: "center",
  justifyContent: "center",
  display: "flex",
  borderLeft: `2px solid ${theme.palette.divider}`,
  padding: theme.spacing(1, 2),
}));

const StyledDivRow = styled("div")({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  alignItems: "center",
});

function KerfAccordian() {
  const {
    handleClickOptions,
    handleClickKerf,
    showSetbackInput,
    handleChange,
    kerf,
    kerfConfig,
    kerfSetbackDoor,
    kerfSetbackMaterial,
    publicId,
    kerfSetback,
  } = useKerfSelector();

  return (
    <ReusableAccordian
      accordionName="kerf"
      heading="Kerf"
      secondaryHeading="Add kerf?"
      colOrRow="col"
    >
      <StyledDivRow>
        <StyledDivSpacing>
          <div onClick={() => handleClickKerf(kerfChoices.label)}>
            <Choices
              label={kerfChoices.label}
              variant={kerfChoices.label === kerf ? "filled" : "outlined"}
              checkMark={kerfChoices.label === kerf}
              wide={true}
            />
          </div>
        </StyledDivSpacing>
        {kerf && (
          <>
            <StyledDivLeftDivide>
              {options.map((state) => (
                <div
                  key={state.id}
                  onClick={() => handleClickOptions(state.label)}
                >
                  <Choices
                    label={state.label}
                    disabled={false}
                    variant={state.label === kerfConfig ? "filled" : "outlined"}
                    checkMark={state.label === kerfConfig}
                  />
                </div>
              ))}
            </StyledDivLeftDivide>

            {showSetbackInput && (
              <RowLayout style={{ marginBottom: 50 }}>
                <StyledFormControl>
                  <InputLabel>KF</InputLabel>
                  <Select
                    value={kerfSetback}
                    onChange={handleChange}
                    label="KF"
                  >
                    <MenuItem value="">
                      <em>None</em>
                    </MenuItem>
                    {KerfCustomOptions({
                      door: kerfSetbackDoor,
                      material: kerfSetbackMaterial,
                    })}
                  </Select>
                </StyledFormControl>
              </RowLayout>
            )}
          </>
        )}
      </StyledDivRow>

      {kerf && (
        <RowLayout>
          <div>
            <Image cloudName="ag-millworks" secure="true" publicId={publicId} />
          </div>
        </RowLayout>
      )}
    </ReusableAccordian>
  );
}

export default memo(KerfAccordian);
